import { DialogTitle } from "@headlessui/react";
import { useQueryClient } from "@tanstack/react-query";

import { JSX } from "react";
import { useTranslation } from "react-i18next";
import { useSearchParams } from "react-router-dom";

import Button from "@/components/buttons/Button.tsx";

import { USER_KEYS, useDeleteSession } from "@/hooks/api/user.hooks";
import { useLang } from "@/hooks/useLang";
import useModalRouter from "@/hooks/useModalRouter";
import { onError } from "@/utils/onError";
import { onSuccess } from "@/utils/onSuccess";

const SessionDeviceModal = (): JSX.Element => {
  const { t } = useTranslation();
  const [params] = useSearchParams();

  const sessionId = params.get("session_id");
  const { closeModal } = useModalRouter();

  const { mutate } = useDeleteSession();

  const queryClient = useQueryClient();
  const lang = useLang();

  if (!sessionId) return <></>;

  const handleDelete = () => {
    mutate(sessionId, {
      onSuccess: () => {
        queryClient.invalidateQueries({ queryKey: USER_KEYS.sessions(lang) });
        onSuccess(t("Sessions.delete-success"));
        closeModal();
      },
      onError,
    });
  };

  return (
    <div className="flex max-w-[32.5rem] flex-col items-center">
      <DialogTitle as={"h2"} className={"staff-modal__title mb-10 max-w-[24.0625rem] text-center"}>
        {t("Sessions.end-session-message", { value: "" })}
      </DialogTitle>
      <div className="grid w-full grid-cols-2 gap-6">
        <Button aria-label={t("Actions.cancel")} color={"white"} onClick={closeModal}>
          {t("Actions.cancel")}
        </Button>
        <Button aria-label={t("Sessions.end")} onClick={handleDelete}>
          {t("Sessions.end")}
        </Button>
      </div>
    </div>
  );
};

export default SessionDeviceModal;
